import { render, staticRenderFns } from "./ac-automation-switch.vue?vue&type=template&id=588e7302&"
import script from "./ac-automation-switch.vue?vue&type=script&lang=js&"
export * from "./ac-automation-switch.vue?vue&type=script&lang=js&"
import style0 from "./ac-automation-switch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports